import { FunctionComponent } from 'react';
import './contact.scss';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import ContactForm from '../shared/contactform/contact-form';
import { GetLanguageLabel } from '../shared/tools';
import CommunicationElement from './communication-element';
import { Email, Language, Phone, Place } from '@mui/icons-material';
import H1 from '../shared/html-tags/h1';
import DIV from '../shared/html-tags/div';
import H2 from '../shared/html-tags/h2';
import { Helmet } from 'react-helmet-async';

export type Props = {};

const Contact: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      <Helmet>
        <title>Kontakt - PS IMAGO PRO</title>
        <meta
          name="description"
          content="Kontaktiere uns für persönlichen Support und Beratung zu PS IMAGO PRO, der führenden Analyse- und Reporting-Lösung von Predictive Solutions."
        />
        <meta
          name="keywords"
          content="Kontakt, Support, PS IMAGO PRO, Predictive Solutions, Analyse, Reporting"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/contact" />
      </Helmet>
      <div className="page contact">
        <TopMenu selected="contact"></TopMenu>
        <div className="page-content bg-top1 top-banner">
          <div className="inner-content contact-top-banner">
            <div className="top-left" style={{ height: 'unset' }}>
              <div className="top-left-2" style={{ marginLeft: '0' }}>
                <H1 language="de">
                  Persönlicher Support
                  <br />
                  für deinen Erfolg.
                </H1>
              </div>
            </div>
            <DIV language="de" className="top-right" style={{ display: 'flex' }}>
              <img
                src="/img/contact/contact-524x500.png"
                alt="Roboter telefoniert mit einem PS IMAGO PRO / SPSS User"
                style={{
                  border: 'none',
                  marginTop: '0',
                  maxHeight: '250px',
                  borderRadius: '0',
                }}
              />
            </DIV>
          </div>
          <div className="inner-content">
            <div className="contact-form">
              <div className="left">
                <H2 language="de">Kontakt</H2>
                <div className="slogan">Wir entfesseln das volle Potenzial deiner Datenanalyse</div>
                <div className="contact-details">
                  <CommunicationElement
                    icon={() => <Email />}
                    label={() => (
                      <>
                        <b>Email:</b>
                        <span>hello@2x4.de</span>
                      </>
                    )}
                    link="mailto://hello@2x4.de?subject=Kontaktanfrage"
                  />
                  <CommunicationElement
                    icon={() => <Language />}
                    label={() => (
                      <>
                        <b>Website:</b>
                        <span>predictivesolutions.2x4.de</span>
                      </>
                    )}
                    link={undefined}
                  />

                  <CommunicationElement
                    icon={() => <Phone />}
                    label={() => (
                      <>
                        <b>Telefon:</b>
                        <span>+49 8631 607164</span>
                      </>
                    )}
                    link={undefined}
                  />

                  <CommunicationElement
                    icon={() => <Place />}
                    label={() => (
                      <>
                        <b>Adresse:</b>
                        <span>Fichtenring 8, 84562 Mettenheim, Deutschland</span>
                      </>
                    )}
                    link={undefined}
                  />
                </div>
              </div>
              <div className="right">
                <ContactForm
                  source="predictivesolutions.2x4.de/contact"
                  textfieldLabel={GetLanguageLabel([
                    { language: 'de', label: 'Nachricht' },
                    { language: 'en', label: 'Message' },
                  ])}
                  textfieldPlaceholder={GetLanguageLabel([
                    { language: 'de', label: 'Deine Nachricht an uns' },
                    { language: 'en', label: 'Your Message to us' },
                  ])}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </>
  );
};

export default Contact;
